import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McDropdownLegacy, McInputNew, McTextAreaNew } from "../../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  FUNKSJONSKONTROLL_AVTREKKSSKAP_TESTER_METODER,
  FunksjonskontrollAvtrekksskapTesterEnum,
} from "@mcapps/shared/gkReportConstants";
import {
  IGKFunksjonskontrollAvtrekksskapResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
const FunksjonskontrollAvtrekksskap: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKFunksjonskontrollAvtrekksskapResultater;
}> = ({ data, onUpdateEditData }) => {
  const addOrRemoveTest = (test: FunksjonskontrollAvtrekksskapTesterEnum) => {
    data.inndata.valgtMetode[test] = !data.inndata.valgtMetode[test];
    onUpdateEditData("testResultater.funksjonskontrollAvtrekksskap.inndata.valgtMetode", data.inndata.valgtMetode);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Funksjonskontroll av avtrekksskap</Title>
        <b>Velg hvilke tester som skal utføres?</b>
        <div className="w-25 mb-4">
          <McDropdownLegacy
            filterOptions={FUNKSJONSKONTROLL_AVTREKKSSKAP_TESTER_METODER.map((test) => {
              return {
                ...test,
                isActive: data.inndata.valgtMetode[test.value],
              };
            })}
            onClick={(value) => addOrRemoveTest(value)}
            title="Velg tester"
            color="secondary"
            textColor="text-black"
          />
        </div>
        {data.inndata.valgtMetode[FunksjonskontrollAvtrekksskapTesterEnum.KONTROLLAVBETJENINGSPANEL] === true && (
          <>
            <h4>Kontroll av betjeningspanel</h4>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.kontrollAvBetjeningspanelResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.kontrollAvBetjeningspanelResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.kontrollAvBetjeningspanelResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.kontrollAvBetjeningspanelResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollAvtrekksskapTesterEnum.NOEDTEST] === true && (
          <>
            <h4>Nødtest</h4>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.noedtestResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.noedtestResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.noedtestResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.noedtestResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.noedtestResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.noedtestResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollAvtrekksskapTesterEnum.LYSNIVAA] === true && (
          <>
            <h4>Lysnivå</h4>
            <div className="d-flex flex-column mb-2">
              <McInputNew
                label="Fyll inn måleresultat (lux):"
                value={data.inndata.lysnivaaResultater.maaleresultat}
                onBlur={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.lysnivaaResultater.maaleresultat",
                    Number(e.target.value),
                  )
                }
                normalizeNumbers={true}
                type="text"
                className="w-25"
              />
            </div>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.lysnivaaResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.lysnivaaResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.lysnivaaResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.lysnivaaResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lysnivaaResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.lysnivaaResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollAvtrekksskapTesterEnum.LYDNIVAA] === true && (
          <>
            <h4>Lydnivå</h4>
            <div className="d-flex flex-column mb-2">
              <McInputNew
                label="Fyll inn måleresultat (dB):"
                value={data.inndata.lydnivaaResultater.maaleresultat}
                onBlur={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.lydnivaaResultater.maaleresultat",
                    Number(e.target.value),
                  )
                }
                normalizeNumbers={true}
                type="text"
                className="w-25"
              />
            </div>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.lydnivaaResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.lydnivaaResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.lydnivaaResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.lydnivaaResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lydnivaaResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.lydnivaaResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollAvtrekksskapTesterEnum.DEKONTAMINERINGSARRANGEMENT] === true && (
          <>
            <h4>Dekontamineringsarragement</h4>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.dekontamineringsarrangement.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.dekontamineringsarrangement.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.dekontamineringsarrangement.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.funksjonskontrollAvtrekksskap.inndata.dekontamineringsarrangement.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.dekontamineringsarrangement.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollAvtrekksskap.inndata.dekontamineringsarrangement.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
      </Stack>
    </Paper>
  );
};
export default FunksjonskontrollAvtrekksskap;